import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';

const RADII = [12, 14, 16];
const CSS_VAR = '--listingRadiusPreview';

const panelStyle = {
  position: 'fixed',
  right: 16,
  bottom: 16,
  width: 148,
  zIndex: 100000,
  boxSizing: 'border-box',
  padding: 10,
  background: '#fff',
  border: '1px solid #d6dae2',
  borderRadius: 10,
  boxShadow: '0 8px 20px rgba(45, 55, 72, 0.16)',
  color: '#2b3140',
};

const titleStyle = {
  margin: '0 0 8px',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
};

const rowStyle = {
  display: 'flex',
  gap: 6,
};

const btnStyle = isActive => ({
  all: 'unset',
  boxSizing: 'border-box',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 0',
  border: `1px solid ${isActive ? '#2b3140' : '#d6dae2'}`,
  borderRadius: 8,
  background: isActive ? '#2b3140' : '#fff',
  color: isActive ? '#fff' : '#2b3140',
  fontSize: 12,
  fontWeight: 600,
  cursor: 'pointer',
  textAlign: 'center',
});

const labelStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  marginTop: 8,
  fontSize: 10,
  fontWeight: 600,
  color: '#8a92a3',
};

const inputStyle = {
  flex: 1,
  width: 0,
  margin: 0,
  padding: '5px 6px',
  border: '1px solid #d6dae2',
  borderRadius: 8,
  fontSize: 12,
  fontWeight: 600,
  color: '#2b3140',
  boxSizing: 'border-box',
  minHeight: 0,
};

const applyRadius = px => {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.style.setProperty(CSS_VAR, `${px}px`);
};

const RadiusPreview = () => {
  const location = useLocation();
  const open = new URLSearchParams(location.search).has('radiusPreview');
  const [mounted, setMounted] = useState(false);
  const [radius, setRadius] = useState(16);
  const [custom, setCustom] = useState('16');

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (open) {
      applyRadius(radius);
    }
  }, [open, radius]);

  if (!open || !mounted) {
    return null;
  }

  const selectRadius = px => {
    setRadius(px);
    setCustom(String(px));
  };

  const onCustomChange = event => {
    const value = event.target.value;
    setCustom(value);
    const next = parseInt(value, 10);
    if (Number.isFinite(next) && next >= 0) {
      setRadius(next);
    }
  };

  const panel = (
    <div style={panelStyle}>
      <p style={titleStyle}>Radius</p>
      <div style={rowStyle}>
        {RADII.map(px => (
          <button key={px} type="button" style={btnStyle(radius === px)} onClick={() => selectRadius(px)}>
            {px}
          </button>
        ))}
      </div>
      <label style={labelStyle}>
        Custom
        <input
          type="number"
          min="0"
          inputMode="numeric"
          value={custom}
          style={inputStyle}
          onChange={onCustomChange}
        />
      </label>
    </div>
  );

  return createPortal(panel, document.body);
};

export default RadiusPreview;
